export const _B2C_API_PATH = `https://${window.spaSettings.tenantId}/${window.spaSettings.apiClientId}/Api`;
